{
  "title": "Client Contracts",
  "subtitle": "3PL rate cards — the priced storage, handling, and VAS terms each Client is billed under.",
  "addContract": "Add Contract",
  "view": "View",
  "edit": "Edit",
  "delete": "Delete",
  "table": {
    "contractNumber": "Contract No.",
    "client": "Client",
    "effectiveFrom": "Effective From",
    "effectiveTo": "Effective To",
    "rateLines": "Rate Lines",
    "status": "Status",
    "actions": ""
  },
  "form": {
    "client": "Client",
    "status": "Status",
    "statusActive": "Active",
    "statusExpired": "Expired",
    "statusCancelled": "Cancelled",
    "effectiveFrom": "Effective From",
    "effectiveTo": "Effective To (optional)",
    "currency": "Currency",
    "rateLines": "Rate Lines",
    "chargeCategory": "Category",
    "chargeCode": "Charge Code",
    "basis": "Basis",
    "description": "Description",
    "rate": "Rate",
    "minChargeAmount": "Min Charge",
    "gstRatePercent": "GST %",
    "sacCode": "SAC Code",
    "addLine": "Add Rate Line"
  },
  "discardChanges": "Discard Changes",
  "saveContract": "Save Contract",
  "deleteContract": {
    "message": "This client contract and its rate lines will be permanently removed."
  }
}
